// The table loop: every dinner shows the app to 3–8 friends, and the ones who go on to pay a bill
// themselves are credited to the dinner and the payer who showed them. Shared by the web page and
// the server, so it can't touch the disk.

/**
 * Where a friend's "Start a split" button goes: the payer's referral code (so the payer gets the
 * credit any referral gets) and the dinner it came from (so the stats can follow the loop).
 */
export function loopLink(splitCode: string, payerRef?: string, src: 'next_time' | 'start_split' | 'group_share' | 'pay_note' = 'start_split'): string {
  const q = new URLSearchParams();
  if (payerRef) q.set('ref', payerRef);
  q.set('from', splitCode);
  // Says which button made it, and survives a copy and paste.
  q.set('src', src);
  return `/?${q}`;
}

/** Which share button on the host's share screen a friend's link came from. */
export const SHARE_CHANNELS = ['qr', 'group', 'text', 'copy'] as const;
export type ShareChannel = (typeof SHARE_CHANNELS)[number];
export const shareChannel = (v: unknown): ShareChannel | undefined => (SHARE_CHANNELS as readonly unknown[]).includes(v) ? (v as ShareChannel) : undefined;

/**
 * A friend's link to this dinner (QR, invite, group text), carrying the payer's referral code too.
 * `via`: the share button it came from, so joins can be counted per button.
 */
export function joinLink(splitCode: string, payerRef: string | undefined, src: 'qr' | 'invite' | 'group_share', via?: ShareChannel): string {
  const q = new URLSearchParams();
  if (payerRef) q.set('ref', payerRef);
  q.set('src', src);
  if (via) q.set('via', via);
  return `/s/${splitCode}?${q}`;
}
